import { Paper } from '@mui/material';
import styled from 'styled-components';

export const DraggablePaper = styled(Paper)`
  && {
    margin: 0;
    position: fixed;

    box-shadow: rgba(0, 0, 0, 0.21) 0px 2px 25px;
  }
`;
